import Spinner from "../../../vapor/spinner";
import Button from "../../../vapor/button";
import { useSelector } from "react-redux";
import { RootState } from "../../../../reducers/store";
import { FormattedMessage } from "react-intl";
import { Close } from "@mui/icons-material";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    IconButton,
} from "@vapor/react-material";
import { AggregatedProductInterface } from "../../../../interfaces/products";

interface BuyAggregatedProductsModalProps {
    onConfirm: () => void;
    onCancel: () => void;
    aggregatedProduct: AggregatedProductInterface;
}

const BuyAggregatedProductsModal = (props: BuyAggregatedProductsModalProps) => {
    const aggregatedProductsState = useSelector(
        (state: RootState) => state.aggregatedProducts,
    );
    const allProductsState = useSelector((state: RootState) => state.products);

    const aggregatedBuyableProducts = allProductsState.data.filter((item) => {
        return props.aggregatedProduct.products.find(
            (productInList) => productInList === item.product,
        );
    });
    const price = aggregatedBuyableProducts.reduce(
        (acc: number, aggregatedBuyableProduct: any) => {
            return acc + aggregatedBuyableProduct.price;
        },
        0,
    );

    return (
        <Dialog
            open={true}
            onClose={(_event, reason) => {
                if (reason && reason === "backdropClick") return;
                props.onCancel();
            }}
        >
            <DialogTitle>
                <FormattedMessage id="modals.buy.title" />
                {!aggregatedProductsState.isBuyingAggregatedProducts && (
                    <IconButton
                        color="primary"
                        onClick={() => props.onCancel()}
                    >
                        <Close />
                    </IconButton>
                )}
            </DialogTitle>
            <Divider variant="fullWidth" />
            <DialogContent>
                {aggregatedProductsState.isBuyingAggregatedProducts ? (
                    <div className="bis-modals-buyProduct-content-spinner">
                        <Spinner
                            message={
                                <FormattedMessage id="modals.buy.spinner" />
                            }
                        />
                    </div>
                ) : (
                    <div className="bis-modals-buyProduct-content">
                        <div className="bis-modals-buyProduct-content-text">
                            <FormattedMessage id="modals.buy.buying" />:
                        </div>
                        <div className="bis-modals-buyProduct-content-product">
                            {props.aggregatedProduct.name}
                        </div>
                        <div className="bis-modals-buyProduct-content-text">
                            <FormattedMessage id="modals.buy.description1" />{" "}
                            <strong>{price}</strong>{" "}
                            <FormattedMessage id="modals.buy.description2" />
                        </div>
                    </div>
                )}
            </DialogContent>
            {!aggregatedProductsState.isBuyingAggregatedProducts && (
                <DialogActions>
                    <div className="bis-modals-buyProduct-footer">
                        <Button
                            onClick={() => props.onCancel()}
                            kind="secondary"
                            size="medium"
                        >
                            <FormattedMessage id="actions.cancel" />
                        </Button>
                        <Button onClick={() => props.onConfirm()} size="medium">
                            <FormattedMessage id="actions.buy" />
                        </Button>
                    </div>
                </DialogActions>
            )}
        </Dialog>
    );
};

export default BuyAggregatedProductsModal;
